import { SearchRadiusInMeters } from '@/constants/searchRadius'
import { COUNTRIES_WITH_ALLOWLISTED_BORDERS } from '../../domain/country'
import { isNumber } from '../checks'
import {
  MAX_HIT_COUNT,
  baseSponsorFilterArray,
  baseSponsorFilters
} from '../../lib/constants'
type LocationAddressPart = {
  title: string
}

export type LocationPlusQueryParams = {
  locationTitle: string
  termAttr?: string
  termValue?: string
  geoloc?: { lat: number; lng: number }
  locationAddressParts?: LocationAddressPart[]
  searchRadius?: number | string
  SUDFocusOnly: boolean
  limit?: number
  page?: number
}

type AlgoliaQuery = {
  filters: string
  aroundLatLng?: string
  aroundRadius?: number | string
  aroundPrecision?: number
  getRankingInfo: boolean
  hitsPerPage: number
  page: number
}

export const generateLocationPlusQuery = ({
  geoloc,
  locationTitle,
  locationAddressParts,
  termAttr,
  termValue,
  searchRadius,
  SUDFocusOnly = false,
  limit = MAX_HIT_COUNT,
  page = 0
}: LocationPlusQueryParams): AlgoliaQuery => {
  const query = {} as AlgoliaQuery

  const filters = [baseSponsorFilters]
  const locationIsAllowListedCountry =
    COUNTRIES_WITH_ALLOWLISTED_BORDERS.has(locationTitle)
  const allowlistedCountry = locationIsAllowListedCountry
    ? locationTitle
    : locationAddressParts
        ?.map(({ title }) => title)
        .find((title) => COUNTRIES_WITH_ALLOWLISTED_BORDERS.has(title))

  if (SUDFocusOnly) {
    filters.push(`what_we_treat: "Drug Addiction" OR what_we_treat: Alcohol`)
  }
  if (termAttr && termValue) {
    filters.push(`${termAttr}:"${termValue}"`)
  }

  if (geoloc?.lat && geoloc?.lng) {
    query.aroundLatLng = `${geoloc?.lat}, ${geoloc?.lng}`
  }

  if (!locationIsAllowListedCountry && !query.aroundLatLng) {
    filters.push(`locations: "${locationTitle}"`)
  }

  if (allowlistedCountry) {
    filters.push(`locations: "${allowlistedCountry}"`)
  }

  if (!allowlistedCountry) {
    COUNTRIES_WITH_ALLOWLISTED_BORDERS.forEach((country) => {
      filters.push(`NOT locations: "${country}"`)
    })
  }

  if (query.aroundLatLng && searchRadius) {
    query.aroundRadius = searchRadius
  }
  if (query.aroundLatLng && isNumber(searchRadius)) {
    query.aroundPrecision = searchRadius
  }

  if (
    query.aroundLatLng &&
    isNumber(searchRadius) &&
    (searchRadius === SearchRadiusInMeters.CITY ||
      searchRadius === SearchRadiusInMeters.REGION)
  ) {
    query.aroundRadius = SearchRadiusInMeters.COUNTRY
    query.aroundPrecision = SearchRadiusInMeters.CITY
  }
  query.getRankingInfo = true
  query.filters = filters.join(' AND ')

  query.hitsPerPage = limit
  query.page = page
  return query
}
